import { Alert, AlertTitle } from '@customink/pigment-react';
import type { Product } from '@customink/project-service-react-components';

import AlternativeColors from './AlternativeColors';
import AlternativeStyle from './AlternativeStyle';
import NoAlternative from './NoAlternative';
import { getHighColorMode } from './util';
import type { HighColorMode } from './util';

import {
  HIGH_COLOR_DESIGN_COLOR_COUNT,
  HIGH_COLOR_DESIGN_MIN_ORDER_QUANTITY,
  WCIBMO_NAMES,
} from '@/constants';
import { usePageViewWCIBMO } from '@/hooks/Analytics/usePageViewWCIBMO';

const HIGH_COLOR_MODES = {
  altColor: AlternativeColors,
  altStyle: AlternativeStyle,
  noAlt: NoAlternative,
} as const;

type MinHighColorQtyProps = {
  product?: Product;
  designCid?: string;
};

export default function MinHighColorQty({
  product,
  designCid,
}: MinHighColorQtyProps) {
  usePageViewWCIBMO(WCIBMO_NAMES.RAISE_ABOVE_HIGH_COLOR_MIN_OR_STYLE);
  if (!product || !designCid) return null;

  const mode: HighColorMode = getHighColorMode(product);
  const AlertBody = HIGH_COLOR_MODES[mode];

  return (
    <Alert data-testid="min-qty-high-color-alert" severity="error">
      <AlertTitle>
        The minimum order quantity for a design with{' '}
        {HIGH_COLOR_DESIGN_COLOR_COUNT} or more colors on a side is{' '}
        {HIGH_COLOR_DESIGN_MIN_ORDER_QUANTITY}.
      </AlertTitle>
      <AlertBody designCid={designCid} product={product} />
    </Alert>
  );
}
